<template>
  
  <div class="cta-circle d-none d-lg-flex flex-column align-items-center justify-content-center p-4" 
    v-on:click="ctaClicked"
    :style="{backgroundColor: color ? '#' + color : 'red' }"
    :class="{'appear': appear}">
    <div class="w-100 guide-text2 text-center mt-2 mb-2 px-4">{{ label }}</div>
    <div class="mb-2">
    <SVGArrow v-if="direction == 'right'" class="arrow"></SVGArrow>
    <SVGArrow v-else class="arrow down"></SVGArrow>
    </div>
    
  </div>
  
</template>

<script>
import SVGArrow from '@/assets/icons/arrow.svg'

export default {
  name: 'CtaCircle',
  components: {
    SVGArrow
  },
  props: [
    'label',
    'trigger',
    'direction',
    'color',
    'appear',
    'offset'
  ],
  mounted(){
    var dur = this.windowHeight
    if(this.$props.trigger){
      const scene = this.$scrollmagic.scene({
        triggerElement: this.$props.trigger,
        triggerHook: 0,
        offset: this.$props.offset ? this.$props.offset : 0,
        duration: dur * 2.5
      })
      this.$scrollmagic.addScene(
      scene
          .setClassToggle(this.$el, 'appear')
          //.addIndicators()
      )  
    }
  },
  methods: {
      ctaClicked(){
          this.$emit('clicked')
      },
      setAppear(value){
        this.appear = value
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.cta-circle{
    width: 250px;
    height: 250px;
    min-width: 250px;
    min-height: 250px;
    border-radius: 50%;
    transform: scale(0.0);
    opacity: 0.2;
    transition: all 0.3s cubic-bezier(0.075, 0.82, 0.165, 1) 0.3s;
    cursor: pointer;
    background-image: url(../../assets/images/distressed-bg.png);
    /* background-blend-mode: multiply; */
    background-repeat: no-repeat;
    background-size: cover;
    
}
.cta-circle.appear{
    transform: scale(1.0);
    opacity: 0.9;
}
.guide-text2 {
  color: white;
  transform: rotate(-2deg);
}
svg g {
  fill: white;
}
.cta-circle.appear .arrow {
  animation: shake-lr 1.0s cubic-bezier(0.455, 0.030, 0.515, 0.955) 0.3s both;
}
.arrow {
  width: 80px;
}
.cta-circle .arrow.down {
  transform: rotate(90deg);
}
.cta-circle.appear .arrow.down{
  animation: none;
}
.bounce-left {
	animation: bounce-left 0.8s both;
}
@keyframes shake-lr {
  0%,
  100% {
    transform: rotate(0deg);
    transform-origin: 50% 50%;
  }
  10% {
    transform: rotate(6deg);
  }
  20%,
  40%,
  60% {
    transform: rotate(-10deg);
  }
  30%,
  50%,
  70% {
    transform: rotate(10deg);
  }
  80% {
    transform: rotate(-6deg);
  }
  90% {
    transform: rotate(6deg);
  }
}

</style>

